<div *ngIf="errorMessage">
	<div [ngSwitch]="designType">
		<div class="login-error-alert" *ngSwitchCase="'OLD_DESIGN'">
			<nz-alert nzType="error" class="global-error-state" [nzDescription]="errorDescription"
				[nzMessage]="errorMessage" nzShowIcon>
			</nz-alert>
		</div>
		<div *ngSwitchCase="'KAMONA_DESIGN'">
			<div class="custom-global-error-state custom-global-error-state-font">
				<div nz-row nzAlign="middle">
					<div nz-col nzSpan="2">
						<span style="position: relative;top:.1em">
							<svg width="24" height="25" viewBox="0 0 24 25" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M12 22.2577C6.47715 22.2577 2 17.7805 2 12.2577C2 6.73484 6.47715 2.25769 12 2.25769C17.5228 2.25769 22 6.73484 22 12.2577C21.9939 17.778 17.5203 22.2516 12 22.2577ZM11 15.2577V17.2577H13V15.2577H11ZM11 7.25769V13.2577H13V7.25769H11Z"
									fill="#E94444" />
							</svg>
						</span>
					</div>
					<div nz-col nzSpan="22">
						<div class="m-l-15">
							<div class="custom-global-error-state-title">
								{{errorDescription}}
							</div>
							<div class="{{errorDescription?'':'custom-global-error-state-title'}}">
								{{errorMessage}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngSwitchCase="'VERSION_3'">
			<div class="custom-global-error-state custom-global-error-state-font">
				<div class="flex items-center w-full gap-4">
					<div>
						<span style="position: relative;top:.1em">
							<svg width="24" height="25" viewBox="0 0 24 25" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M12 22.2577C6.47715 22.2577 2 17.7805 2 12.2577C2 6.73484 6.47715 2.25769 12 2.25769C17.5228 2.25769 22 6.73484 22 12.2577C21.9939 17.778 17.5203 22.2516 12 22.2577ZM11 15.2577V17.2577H13V15.2577H11ZM11 7.25769V13.2577H13V7.25769H11Z"
									fill="#E94444" />
							</svg>
						</span>
					</div>
					<div class="flex flex-col md:flex-row grow md:items-center gap-3 ">
						<div>
							<div>
								<div class="custom-global-error-state-title">
									{{errorDescription}}
								</div>
								<div class="{{errorDescription?'':'custom-global-error-state-title'}}">
									{{errorMessage}}
								</div>
							</div>
						</div>
						<div class="ml-0 md:ml-auto self-start" *ngIf="showSubmit">
							<ng-container *ngTemplateOutlet="retryButton"></ng-container>
						</div>
					</div>
				</div>
			</div>
			<ng-template #retryButton>
				<app-custom-button text="Retry" (submitForm)="onActionClicked()"></app-custom-button>
			</ng-template>
		</div>

		<div *ngSwitchCase="'VERSION_4'">
			<div class="custom-global-error-state custom-global-error-state-font">
				<div class="flex items-center w-full gap-4">
					<div class="flex flex-col md:flex-row grow md:items-center gap-3 ">
						<div class="custom-global-error-state-title flex gap-2 items-center">
							<div class="flex self-start">
								<svg width="24" height="25" viewBox="0 0 24 25" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M12 22.2577C6.47715 22.2577 2 17.7805 2 12.2577C2 6.73484 6.47715 2.25769 12 2.25769C17.5228 2.25769 22 6.73484 22 12.2577C21.9939 17.778 17.5203 22.2516 12 22.2577ZM11 15.2577V17.2577H13V15.2577H11ZM11 7.25769V13.2577H13V7.25769H11Z"
										fill="#E94444" />
								</svg>
							</div>
							<div class="flex flex-col gap-2 pt-[2px]">
								<span>{{errorDescription}}</span>
								<span class="text-neutral-black-100 font-normal">
									{{errorMessage}}
								</span>
							</div>
						</div>
						<div class="ml-0 md:ml-auto self-start" *ngIf="showSubmit">
							<ng-container *ngTemplateOutlet="retryButton"></ng-container>
						</div>
					</div>
				</div>
			</div>
			<ng-template #retryButton>
				<app-custom-button text="Retry" (submitForm)="onActionClicked()"></app-custom-button>
			</ng-template>
		</div>
	</div>
</div>